export enum NotificationCode {
  SLEEP_REMINDER = 'SLEEP_REMINDER',
  WAKE_UP_REMINDER = 'WAKE_UP_REMINDER',
  FRIEND_WAKE_UP_REMINDER = 'FRIEND_WAKE_UP_REMINDER',
  CONTEXT_CONTENT_REMINDER = 'CONTEXT_CONTENT_REMINDER',
  PRAYER_LOG_REMINDER = 'PRAYER_LOG_REMINDER',
  WAKE_UP_INVITATION = 'WAKE_UP_INVITATION',
  WAKE_UP_RING = 'WAKE_UP_RING',
  BROADCAST = 'BROADCAST',
}
